export const COPILOT_CLOUD_API_URL = "https://api.cloud.copilotkit.ai";
export const COPILOT_CLOUD_VERSION = "v1";
export const COPILOT_CLOUD_CHAT_URL = `${COPILOT_CLOUD_API_URL}/copilotkit/${COPILOT_CLOUD_VERSION}`;
export const COPILOT_CLOUD_PUBLIC_API_KEY_HEADER = "X-CopilotCloud-Public-Api-Key";
